<priva-dialog
    [title]="title || 'GENERAL.ACTION.SCAN_QR_CODE' | translate"
    (close)="closeDialog()"
    [buttons]="buttons"
    [hasFooter]="true"
    footerLayout="inline"
    (buttonClick)="buttonClick($event)"
    [type]="dialogType"
    [hasMargin]="false"
>
    <app-scan-qr [allowedCodeTypes]="allowedCodeTypes" (codeScanned)="onCodeScanned($event)" />
</priva-dialog>
